<template>
  <div v-if="supportInformation">
    <b-row>
      <div class="col-lg-4 col-md-6 col-form-label pt-0 pb-0">
        <div class="mb-3">
          <label for="Phone">
            {{ $t('Webportal.SupportInformation.Telephone') }}
          </label>
        </div>
        <div class="mb-3">
          <label for="Reachability">
            {{ $t('Webportal.SupportInformation.Reachability') }}
          </label>
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="mb-3">
          <b-form-input id="Phone"
                        v-model="supportInformation.Phone"
                        @change="v$.supportInformation.Phone.$touch()"
                        size="sm"
                        :disabled="isFieldDisabled('IsPhoneEnabled')"
                        trim>
          </b-form-input>
        </div>
        <div class="mb-3">
          <b-form-input id="Reachability"
                        v-model="supportInformation.Reachability"
                        @change="v$.supportInformation.Reachability.$touch()"
                        size="sm">
          </b-form-input>
        </div>
      </div>

      <label class="col-auto align-self-center">
        {{ $t('Webportal.Visible') }}
        <font-awesome-icon :icon="['fas', 'eye']" />
      </label>
      <div class="col-auto align-self-center">
        <label class="switch switch-label switch-secondary">
          <input  class="switch-input"
                  type="checkbox"
                  :checked="getEnabledValue('IsPhoneEnabled')"
                  @input="setEnabledValue('IsPhoneEnabled', $event.target.checked)"
                  @change="v$.supportInformation.Phone.$touch()"
                  :disabled="disabled">
          <span class="switch-slider" data-checked="On" data-unchecked="Off"></span>
        </label>
      </div>
    </b-row>

    <b-row class="mb-3">
      <label for="EMail" class="col-lg-4 col-md-6 col-form-label pt-0">
        {{ $t('Webportal.SupportInformation.EMail') }}
      </label>
      <div class="col-lg-4 col-md-6">
        <b-form-input id="EMail"
                      v-model="supportInformation.EMail"
                      @change="v$.supportInformation.EMail.$touch()"
                      trim
                      size="sm">
        </b-form-input>
      </div>

      <label class="col-auto">
        {{ $t('Webportal.Visible') }}
        <font-awesome-icon :icon="['fas', 'eye']" />
      </label>
      <div class="col-auto">
        <label class="switch switch-label switch-secondary">
          <input  class="switch-input"
                  type="checkbox"
                  :checked="getEnabledValue('IsEMailEnabled')"
                  @input="setEnabledValue('IsEMailEnabled', $event.target.checked)"
                  @change="v$.supportInformation.EMail.$touch()"
                  :disabled="disabled">
          <span class="switch-slider" data-checked="On" data-unchecked="Off"></span>
        </label>
      </div>
    </b-row>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';

export default {
  name: 'SupportInformation',

  props: {
    value: { type: Object, default: {} },
    disabled: { type: Boolean, default: false }
  },

  setup(props, { expose }) {
    const v$ = useVuelidate();
    expose({ v$ });
    return { v$ };
  },

  validations() {
    return {
      supportInformation: {
        Phone: { required, regex: /^[0-9-+]*$/ },
        IsPhoneEnabled: { required },
        Reachability: { required  },
        EMail: { required, email },
        IsEMailEnabled: { required }
      }
    }
  },

  data() {
    return {
      supportInformation: this.value ?? {}
    };
  },

  computed: {
    isFormChanged() {
      return this.v$.$anyDirty;
    },

    isFormValid() {
      return !this.v$.$error && this.v$.$anyDirty;
    },

  },

  watch: {
    value(newVal, oldVal) {
      this.supportInformation = newVal ?? {};
    },

    supportInformation: {
      handler(newVal) {
        this.$emit("input", newVal);
        this.$emit("validation", {
          valid: !this.v$.$error,
          dirty: this.v$.$anyDirty
        });
      },
      deep: true
    }
  },

  methods: {
    isFieldDisabled(settingName) {
      return this.disabled || this.getEnabledValue(settingName) == false;
    },

    getEnabledValue(settingName) {
      return this.supportInformation[settingName] ?? true;
    },

    setEnabledValue(settingName, newValue) {
      this.supportInformation[settingName] = newValue;
    }
  }
}
</script>
